import React from 'react';
import PropTypes from 'prop-types';
import {Chip} from 'views/components';
import contrast from 'css/Contrast';
import {translate} from 'views/module';

const JobStatusView = (props) => {
  const {
    jobData,
    setIsEditing,
  } = props;

  const status = jobData.status;

  const title = translate(`career.Status.${status}.Title`);
  const color = translate(`career.Status.${status}.Color`);
  const textColor = contrast(color);

  return (
    <Chip
      label={title}
      sx={{
        backgroundColor: color,
        color: textColor,
        cursor: 'pointer',
      }}
      onClick={() => setIsEditing(true)}
    />
  );
};

JobStatusView.propTypes = {
  jobData: PropTypes.object.isRequired,
  setIsEditing: PropTypes.func.isRequired,
};

export default React.memo(JobStatusView);
